import {IFilterFunction} from "angular";
import {TimeSeriesPeriod, timeSeriesPeriodName} from "../types/TimeSeriesPeriod";

export const TimeSeriesPeriodTranslateFilter = "tfTimeSeriesPeriodTranslate";

export function timeSeriesPeriodTranslateFilter(): IFilterFunction {
    return (period: TimeSeriesPeriod | null) => {
        if (period == null) {
            return null;
        } else {
            return `time-series-period.${period}`;
        }
    };
}
